import { render, staticRenderFns } from "./Conversions.vue?vue&type=template&id=d1bfaf2c&scoped=true"
import script from "./Conversions.vue?vue&type=script&lang=ts"
export * from "./Conversions.vue?vue&type=script&lang=ts"
import style0 from "./Conversions.vue?vue&type=style&index=0&id=d1bfaf2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bfaf2c",
  null
  
)

export default component.exports